// @flow
import React, { type Node } from 'react';
import reduce from 'ramda/es/reduce';
import { useTranslation } from 'react-i18next';

import RowLayout from 'app/common/layouts/RowLayout';
import Loading from 'app/common/components/Loader';
import EmptyWarn from 'app/common/layouts/EmptyWarn';

import styles from './StatementsLayout.scss';


type Props = {
  children: Node,
  sideTop: Node,
  sideMain: Node,
}

const StatementsLayout = ({ children, sideTop, sideMain }: Props) => {
  const { t } = useTranslation('statements');

  const isEmptyChildren = !(children instanceof Array
    ? reduce((val, acc) => (val || acc), false, children)
    : children);

  return (
    <div className={styles.root}>
      <div className={styles.side}>
        <div className={styles.sideTop}>{sideTop}</div>
        <RowLayout className={styles.sideMain} paddingfree>
          {sideMain}
        </RowLayout>
      </div>
      <div className={styles.main}>
        {!isEmptyChildren
          ? children
          : <RowLayout className={styles.emptyFiller} paddingfree>
            <EmptyWarn>
              {t('empty')}
            </EmptyWarn>
          </RowLayout>}
      </div>
    </div>
  );
};

export default StatementsLayout;
